export default __webpack_public_path__ + "static/media/conceito.0a9885df.jpeg";